/**
 * Filtrage calendrier public / membre / dojo.
 */
export function isPublicEvent(event) {
  return event?.visibilite === "public" && event?.statut === "actif";
}

/**
 * @param {object[]} events
 * @param {object} viewer
 * @param {object} [membership]
 */
export function filterEventsForViewer(events, viewer, membership) {
  const list = Array.isArray(events) ? events : [];
  const role = viewer?.role || "guest";
  const isGuest = !viewer || role === "guest";
  if (isGuest) {
    return list.filter(isPublicEvent);
  }
  const dojoId = membership?.identity?.dojoId || membership?.dojoId || viewer.dojoId || null;
  const isAdmin = role === "hanshi" || role === "admin";
  const isActive = membership?.status === "active" || isAdmin || role === "sensei" || role === "assistant";
  const isBd = membership?.blackDragon?.status === "active";

  return list.filter((event) => {
    if (event.visibilite === "public") return event.statut === "actif" || isAdmin;
    if (event.visibilite === "admin") return isAdmin;
    if (event.visibilite === "black_dragon") return isBd || isAdmin;
    if (event.visibilite === "membres") {
      if (!isActive) return false;
      if (!event.dojo_id || event.dojo_id === dojoId) return true;
      if (isAdmin) return true;
      return false;
    }
    return false;
  });
}

export function nextUpcoming(events, fromDate = new Date()) {
  const iso = fromDate.toISOString().slice(0, 10);
  return [...events]
    .filter((e) => e.date && e.date >= iso)
    .sort((a, b) => String(a.date).localeCompare(String(b.date)))[0] || null;
}

export function mapsDirectionsUrl(dojo) {
  if (!dojo) return "";
  const q = [dojo.adresse, dojo.ville, dojo.province || "Québec"].filter(Boolean).join(", ");
  if (!q.trim()) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}
